import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import { storeCatalogApi, type StoreProductListParams } from '../api/store-catalog-api';

import { storeCatalogKeys } from './store-catalog-keys';

/** Shared by the route loader (prefetch) and the page hook (subscribe). */
export function storeProductListQueryOptions(storeId: string, params: StoreProductListParams) {
  return queryOptions({
    queryKey: storeCatalogKeys.list(storeId, params),
    queryFn: () => storeCatalogApi.list(storeId, params),
    placeholderData: keepPreviousData,
  });
}

export function useStoreProducts(storeId: string, params: StoreProductListParams) {
  return useQuery(storeProductListQueryOptions(storeId, params));
}

/** The store product of one master product in a store, or null when it is not published there. */
export function storeMembershipQueryOptions(storeId: string, productId: string) {
  return queryOptions({
    queryKey: storeCatalogKeys.membership(storeId, productId),
    queryFn: () =>
      storeCatalogApi.list(storeId, { productId, limit: 1 }).then((r) => r.items[0] ?? null),
  });
}

export function useStoreMembership(storeId: string, productId: string) {
  return useQuery(storeMembershipQueryOptions(storeId, productId));
}
